import { ExpandButton } from 'mol-ui';
import { coverageActions } from 'core/Coverage';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    ButtonDiv,
    Content
} from './styled';
import {
    ListingItem,
    ListingLayout
} from 'views/components';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const CoverageListing = () => {

    const dispatch = useDispatch();
    const { listingCoverage } = useTheme();
    const { t } = useTranslation();
    const { push } = useHistory();
    const {
        list: coveragesList = [],
        loading
    } = useSelector('coverage');

    useEffect(() => {
        dispatch(coverageActions.getCoverageListing({ only_has_plans: 0 }));
    }, []);

    const handleFilter = filter => dispatch(coverageActions.getCoverageListing(filter));

    const handleSelection = coverage => mode => {
        dispatch(coverageActions.setCoverageSelected(coverage));
        push(`${ t('/coberturas') }/${ mode }/${ coverage.id }`);
    };

    const renderPlans = array => array ? array.map(({ name }) => name).join(' - ') : t('Sin planes');

    return (
        <ListingLayout loading={ loading } onFilterChange={ handleFilter }>
            <Content>
                {
                    coveragesList
                        ? coveragesList.map(coverage => (
                            <ListingItem
                                color={ listingCoverage }
                                icon="credit_card"
                                key={ coverage.id }
                                text={ renderPlans(coverage.plans) }
                                title={ coverage.business_name }
                                onActionClick={ handleSelection(coverage) }
                            />
                        ))
                        : <div>{ t('No hay coberturas') }...</div>
                }
            </Content>
            <ButtonDiv>
                <ExpandButton
                    caption={ t('Nueva cobertura médica') }
                    size={ 150 }
                    onClick={ () => push(t('/coberturas/crear')) }
                />
            </ButtonDiv>
        </ListingLayout>
    );
};

export default CoverageListing;
